/* Nightholm buy box. Ported from preview.html (15 Oct 2026, heated + fur, direct-response layout).
   One instance per section. Data comes from the <script type="application/json" data-nh-buy> blob
   emitted by sections/nh-buy-box.liquid: the page product, the other product, swatch hex maps,
   the bundle cards (Buy 1 / 2 / 4), money format, labels.

   Four slots. Slot 1 is always the page product and follows the swatches and size buttons at the
   top (and they follow it). Slots 2 to 4 copy slot 1 until the customer changes them; each can be
   this product or the other one, any size, any colour.

   Pricing: every total (card totals, subtotal and saving pill, unlocked box, sticky bar) comes from
   window.NHPricing (assets/nh-pricing.js, a byte-for-byte copy of ../pricing/pricing.js, the same rule the
   store's discount uses): NHPricing.price(classes) on NHPricing.classOf(handle, Size value) of each blanket in
   the bundle's slots. Compare-at totals are the sum of the chosen variants' compare-at prices. If a blanket has
   no price class (or the pricing file failed to load) the page shows the plain sum of the variant prices, with
   no saving, rather than a guess. The add-to-cart posts every blanket of the active bundle in ONE
   /cart/add.js call. */
(function () {
  'use strict';

  function lum(h) {
    if (!h || h.length < 7) return 0;
    var r = parseInt(h.slice(1, 3), 16) / 255, g = parseInt(h.slice(3, 5), 16) / 255, b = parseInt(h.slice(5, 7), 16) / 255;
    var f = function (v) { return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
  }

  /* Button, sticky bar and gallery tint take the chosen colour; light colours get ink text and an ink border. */
  /* A swatch value is one hex, or several hexes separated by commas for a tie-dye (drawn as a blend). */
  function swatchBg(v) {
    var parts = String(v || '').split(',').map(function (x) { return x.trim(); }).filter(function (x) { return /^#[0-9a-fA-F]{6}$/.test(x); });
    if (!parts.length) return '#9a9a97';
    return parts.length === 1 ? parts[0] : 'linear-gradient(135deg,' + parts.join(',') + ')';
  }
  function applyColour(root, hex) {
    var all = swatchBg(hex);
    hex = String(hex || '').split(',')[0].trim();
    if (!/^#[0-9a-fA-F]{6}$/.test(hex || '')) hex = '#9a9a97';
    // text colour = whichever of white or ink reads better on this blanket colour (WCAG contrast)
    var L = lum(hex), cW = 1.05 / (L + 0.05), cI = (L + 0.05) / (lum('#1e1e1e') + 0.05);
    var dark = cW >= cI;
    // Buttons stay brand olive whatever the colour (Sami, 20 Oct 2026); only the empty gallery takes the colour.
    var m = root.querySelector('.gallery .main');
    if (m && !m.classList.contains('has-media')) { m.style.background = all.indexOf('gradient') > -1 ? all : 'linear-gradient(160deg,' + hex + 'cc,' + hex + 'ff)'; m.style.color = dark ? '#fff' : '#1e1e1e'; }
  }

  /* Formats cents with the shop money format. keepZeros=false drops a trailing ".00"
     (same output as Liquid's money_without_trailing_zeros). */
  function money(cents, format, keepZeros) {
    var n = Math.round(cents) / 100;
    var fixed = n.toFixed(2);
    var parts = fixed.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var out = (format || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(n).toLocaleString('en-US'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(n).toLocaleString('de-DE'));
    if (keepZeros) return out;
    return out.replace(/\.00(?!\d)/, '').replace(/,00(?!\d)/, '');
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* "Medium, 51 x 63 in (130 x 160 cm)" -> short "Medium", dim "51 x 63 in (130 x 160 cm)" */
  function splitSize(s) {
    s = String(s == null ? '' : s); var i = s.indexOf(',');
    return i < 0 ? { short: s.trim(), dim: s.trim() } : { short: s.slice(0, i).trim(), dim: s.slice(i + 1).trim() };
  }

  /* Normalises a Shopify product JSON into {handle, title, colourIdx, sizeIdx, colours, sizes, sizePrice, sizesDiffer, variants}. */
  function model(p, swatches) {
    if (!p || !p.variants) return null;
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    var colourIdx = -1, sizeIdx = -1;
    names.forEach(function (n, i) {
      var l = n.toLowerCase();
      if (colourIdx < 0 && (l === 'colour' || l === 'color')) colourIdx = i;
      if (sizeIdx < 0 && l === 'size') sizeIdx = i;
    });
    var optOf = function (v, i) { if (v.options && v.options.length) return v.options[i]; return v['option' + (i + 1)]; };
    var colours = [], sizes = [], sizePrice = {};
    p.variants.forEach(function (v) {
      if (colourIdx >= 0) { var c = optOf(v, colourIdx); if (c && colours.indexOf(c) < 0) colours.push(c); }
      if (sizeIdx >= 0) { var s = optOf(v, sizeIdx); if (s && sizes.indexOf(s) < 0) { sizes.push(s); sizePrice[s] = v.price; } }
    });
    var sizesDiffer = sizes.some(function (z) { return sizePrice[z] !== sizePrice[sizes[0]]; });
    return { handle: p.handle, title: p.title, colourIdx: colourIdx, sizeIdx: sizeIdx, colours: colours, sizes: sizes, sizePrice: sizePrice, sizesDiffer: sizesDiffer, variants: p.variants, optOf: optOf, swatches: swatches || {} };
  }

  function findVariant(m, colour, size) {
    if (!m) return null;
    var exact = null, byColour = null;
    m.variants.forEach(function (v) {
      var okC = m.colourIdx < 0 || m.optOf(v, m.colourIdx) === colour;
      var okS = m.sizeIdx < 0 || m.optOf(v, m.sizeIdx) === size;
      if (okC && okS && !exact) exact = v;
      if (okC && !byColour) byColour = v;
    });
    return exact || byColour || m.variants[0];
  }

  function init(root) {
    var dataEl = root.querySelector('script[type="application/json"][data-nh-buy]');
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var thisM = model(data.product, data.swatches[data.product && data.product.handle]);
    var otherM = model(data.other, data.swatches[data.other && data.other.handle]);
    if (!thisM) return;
    var products = {}; products[thisM.handle] = thisM; if (otherM) products[otherM.handle] = otherM;
    var shortName = {}; shortName[thisM.handle] = data.labels.thisShort || thisM.title; if (otherM) shortName[otherM.handle] = data.labels.otherShort || otherM.title;
    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var fmt = function (c) { return money(c, data.moneyFormat, true); };
    var fmtShort = function (c) { return money(c, data.moneyFormat, false); };

    /* slot 1 starts on what Liquid rendered (the ?variant= in the URL, or the first available variant) */
    var startColour = (q('.sw.on') && q('.sw.on').dataset.colour) || thisM.colours[0] || null;
    var startSize = (q('.size.on[data-size]') && q('.size.on[data-size]').dataset.size) || root.dataset.startSize || thisM.sizes[0] || null;
    var slots = [0, 1, 2, 3].map(function () { return { h: thisM.handle, colour: startColour, size: startSize, touched: false }; });
    var swatchClicked = false;
    // size a slot opens on when its blanket type is switched: this product's opening size, the other's default size
    var defSize = {}; defSize[thisM.handle] = startSize;
    if (otherM) {
      var od = data.labels.otherDefaultSize, odz = null;
      if (od) otherM.sizes.forEach(function (z) { if (!odz && splitSize(z).short === od) odz = z; });
      defSize[otherM.handle] = odz || otherM.sizes[0] || null;
    }
    // card selected when the page opens: the section setting (Buy 1 Get 1 by default, Sami 21 Oct 2026), if that card exists
    var active = +(data.defaultBundle || 2); if (!root.querySelector('.bundle[data-n="' + active + '"]')) active = 1;

    function variantOf(slot) { return findVariant(products[slot.h], slot.colour, slot.size); }
    function sizeOf(slot, v) { var m = products[slot.h]; return m.sizeIdx >= 0 ? m.optOf(v, m.sizeIdx) : ''; }

    /* full = the blankets at their own prices, comp = compare-at prices, total = what the cart will charge */
    function price(n) {
      var full = 0, comp = 0, comps = [], classes = [], priced = !!(window.NHPricing && typeof window.NHPricing.price === 'function');
      for (var i = 0; i < n; i++) {
        var sl = slots[i], v = variantOf(sl); if (!v) continue;
        var p = Math.round(v.price), c = v.compare_at_price && v.compare_at_price > p ? Math.round(v.compare_at_price) : p;
        full += p; comp += c; comps.push(c);
        var cls = priced ? window.NHPricing.classOf(sl.h, sizeOf(sl, v)) : null;
        if (!cls) priced = false; else classes.push(cls);
      }
      var total = full;
      if (priced && classes.length) { var r = window.NHPricing.price(classes); total = r.total; full = r.full; }
      return { full: full, comp: comp, total: total, comps: comps };
    }

    function setText(sel, txt) { qa(sel).forEach(function (el) { el.textContent = txt; }); }

    /* ---- top of the buy box: swatches, size buttons, labels, colour, hidden variant id, stock */
    function renderTop() {
      var s0 = slots[0];
      qa('.sw').forEach(function (b) { b.classList.toggle('on', b.dataset.colour === s0.colour); });
      setText('[data-sw-name]', s0.colour || '');
      var sw = qa('.sw').filter(function (b) { return b.dataset.colour === s0.colour; })[0];
      applyColour(root, sw ? sw.dataset.hex : thisM.swatches[s0.colour]);
      if (thisM.sizeIdx >= 0) {
        qa('.size[data-size]').forEach(function (b) { b.classList.toggle('on', b.dataset.size === s0.size); });
        setText('[data-size-name]', splitSize(s0.size).dim);
        qa('[data-guide]').forEach(function (g) { g.hidden = g.dataset.guide !== splitSize(s0.size).short; });
      }
      var v = variantOf(s0);
      var input = q('input[name="id"]'); if (input && v && String(input.value) !== String(v.id)) { input.value = v.id; input.dispatchEvent(new Event('change', { bubbles: true })); }
      var stock = q('.stockbar');
      if (stock && v) {
        var avail = v.available !== false;
        stock.classList.toggle('out', !avail);
        var t = stock.querySelector('[data-stock-text]'); if (t) t.textContent = avail ? data.labels.inStock : data.labels.soldOut;
      }
      /* a variant image whose alt starts with "swatch:" is the colour grid: it replaces the main photo only after a real swatch
         click (the page opens on the hero, even though a colour is pre-selected) and has no thumbnail (never in the carousel) */
      if (swatchClicked && v && v.featured_image && v.featured_image.src) showMain(gridUrl(v.featured_image.src), v.featured_image.alt || thisM.title);
    }

    /* ---- slot pickers inside every bundle card (re-drawn from the slot state on every change) */
    function opt(value, label, selected) { return '<option value="' + escapeHtml(value) + '"' + (selected ? ' selected' : '') + '>' + escapeHtml(label) + '</option>'; }
    function typeOrder() { return otherM ? (data.labels.otherFirst ? [otherM, thisM] : [thisM, otherM]) : [thisM]; }
    function renderPicks() {
      qa('.bundle').forEach(function (card) {
        var n = +card.dataset.n, box = card.querySelector('.picks'); if (!box) return;
        var h = '';
        for (var i = 0; i < n; i++) {
          var sl = slots[i], m = products[sl.h], first = i === 0;
          var hex = (m.swatches && m.swatches[sl.colour]) || '#9a9a97';
          var sizeShort = sl.size ? splitSize(sl.size).short : '';
          /* dark tile "BLANKET / n", then a white box: colour dot, product name, "Size · Colour", then the menus.
             Slot 1 is the page product, so it has no type menu. */
          h += '<span class="slot pick' + (first ? ' fixed' : '') + '" data-i="' + i + '">' +
            '<span class="tile"><small>' + escapeHtml(data.labels.slot) + '</small><b>' + (i + 1) + '</b></span>' +
            '<span class="box"><i class="dot" style="background:' + escapeHtml(swatchBg(hex)) + '"></i>' +
            '<span class="nm"><b>' + escapeHtml(m.title) + '</b><span>' + escapeHtml([sizeShort, sl.colour].filter(Boolean).join(' · ')) + '</span></span><span class="sels">';
          if (!first && otherM) h += '<select data-f="type" class="ptype-sel" aria-label="' + escapeHtml(data.labels.typeAria) + '">' + typeOrder().map(function (x) { return opt(x.handle, shortName[x.handle], x.handle === sl.h); }).join('') + '</select>';
          if (m.sizes.length) h += '<select data-f="size" class="psize" aria-label="' + escapeHtml(data.labels.sizeAria) + '">' + m.sizes.map(function (z) { return opt(z, splitSize(z).short, z === sl.size); }).join('') + '</select>';
          if (m.colours.length) h += '<select data-f="colour" class="pcol" aria-label="' + escapeHtml(data.labels.colourAria) + '">' + m.colours.map(function (c) { return opt(c, c, c === sl.colour); }).join('') + '</select>';
          h += '</span></span></span>';
        }
        box.innerHTML = h;
        box.querySelectorAll('select').forEach(function (sel) {
          sel.addEventListener('click', function (e) { e.stopPropagation(); });
          sel.addEventListener('change', function () {
            var i = +sel.closest('.pick').dataset.i, f = sel.dataset.f, ch = {};
            if (f === 'type') { var m = products[sel.value]; if (!m) return; ch = { h: m.handle, size: defSize[m.handle] || m.sizes[0] || null, colour: m.colours[0] || null }; }
            else ch[f] = sel.value;
            setSlot(i, ch);
          });
        });
      });
    }

    /* ---- every price on the box: card totals and compare totals, the per-blanket lines, the unlocked box,
       the subtotal and saving pill, the sticky bar. The add-to-cart button carries no price. */
    function renderPrices() {
      qa('.bundle').forEach(function (card) {
        var n = +card.dataset.n, p = price(n);
        card.classList.toggle('on', n === active);
        var nEl = card.querySelector('.p .n'); if (nEl) nEl.textContent = fmt(p.total);
        var wEl = card.querySelector('.p .w'); if (wEl) wEl.textContent = p.comp > p.total ? fmtShort(p.comp) : '';
        var each = fmt(Math.floor(p.total / n)) + ' ' + (data.labels.each || '');   /* the card total / n, rounded down to the cent */
        var line = card.querySelector('[data-perline]');
        if (line) line.innerHTML = (line.dataset.free ? escapeHtml(line.dataset.free) + ' · ' : '') + '<b>' + escapeHtml(each) + '</b>';
        /* Buy 1 line is the description only; the price sits on the right of the card (Sami, 21 Oct 2026) */
      });
      var a = price(active);
      setText('[data-sub-now]', fmt(a.total));
      setText('[data-sub-was]', a.comp > a.total ? fmt(a.comp) : '');
      qa('[data-save-pill]').forEach(function (el) { el.innerHTML = a.comp > a.total ? escapeHtml(data.labels.saving) + ' <b>' + escapeHtml(fmt(a.comp - a.total)) + '</b>' : ''; });
      setText('[data-price-now]', fmt(a.total));
      setText('[data-price-was]', a.comp > a.total ? fmtShort(a.comp) : '');
      /* unlocked box: the free blankets are valued at the compare-at price of the cheapest 1 (Buy 2) or 2 (Buy 4) */
      var freeN = active > 1 ? Math.floor(active / 2) : 0;
      var freeVal = a.comps.slice().sort(function (x, y) { return x - y; }).slice(0, freeN).reduce(function (t, c) { return t + c; }, 0);
      setText('[data-unlock-hd]', freeN ? data.labels.unlocked : data.labels.included);
      setText('[data-unlock-free]', freeN ? (freeN === 1 ? data.labels.freeOne : data.labels.freeMany) : data.labels.freeBuy1);
      qa('[data-unlock-was]').forEach(function (el) { el.classList.toggle('blank', !freeN); el.textContent = freeN ? fmt(freeVal) : ' '; });
      setText('[data-unlock-ft]', freeN ? data.labels.footBundle : data.labels.footBuy1);
    }

    function renderAll() { renderTop(); renderPicks(); renderPrices(); }

    /* slot 1 changes copy into every slot the customer has not touched yet */
    function setSlot(i, ch) {
      Object.keys(ch).forEach(function (k) { slots[i][k] = ch[k]; });
      if (i > 0) slots[i].touched = true;
      else for (var j = 1; j < slots.length; j++) if (!slots[j].touched) { slots[j].h = slots[0].h; slots[j].size = slots[0].size; slots[j].colour = slots[0].colour; }
      renderAll();
    }

    /* gallery */
    /* one width per screen class, so the preload and the click share the same cached file */
    function gridUrl(src) {
      if (!src || /[?&]width=/.test(src)) return src;
      var main = q('.gallery .main'), w = main ? main.clientWidth : 500, dpr = Math.min(window.devicePixelRatio || 1, 2);
      var px = w * dpr, size = px <= 600 ? 600 : px <= 800 ? 800 : 1100;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + size;
    }
    function showMain(src, alt) {
      var main = q('.gallery .main'); if (!main) return;
      var img = main.querySelector('img');
      if (!img) { main.textContent = ''; img = document.createElement('img'); main.appendChild(img); main.classList.add('has-media'); main.style.background = ''; }
      qa('.thumbs .ph-img').forEach(function (th) { th.classList.toggle('on', th.dataset.src === src); });
      /* keep the current photo on screen until the new one has loaded, then swap (no blank flash) */
      var want = src; main.dataset.want = want;
      var apply = function () { if (main.dataset.want !== want) return; img.src = want; if (img.srcset) img.removeAttribute('srcset'); if (alt) img.alt = alt; };
      var pre = new Image(); pre.onload = apply; pre.onerror = apply; pre.src = want;
      if (pre.complete) apply();
    }
    /* colour grids (variant images whose alt starts with "swatch:") are fetched quietly, one at a time, from the shopper's
       first interaction with the page, so a swatch click shows its photo at once without competing with the first load
       (Sami, 21 Oct 2026: "the colour swatches are super slow"). The product JSON carries the ORIGINAL file (up to ~600 KB);
       gridUrl asks the CDN for the size the photo is shown at. */
    (function preloadSwatchGrids() {
      var urls = [], seen = {};
      (thisM.variants || []).forEach(function (v) { var fi = v.featured_image; if (fi && fi.src && /^swatch:/i.test(fi.alt || '')) { var u = gridUrl(fi.src); if (!seen[u]) { seen[u] = 1; urls.push(u); } } });
      if (!urls.length) return;
      var started = false, evs = ['pointerdown', 'pointermove', 'touchstart', 'scroll', 'keydown'];
      var next = function () { var u = urls.shift(); if (!u) return; var im = new Image(); im.onload = im.onerror = function () { setTimeout(next, 30); }; im.src = u; };
      var start = function () {
        if (started) return; started = true;
        evs.forEach(function (e) { window.removeEventListener(e, start, true); });
        if ('requestIdleCallback' in window) window.requestIdleCallback(next, { timeout: 800 }); else setTimeout(next, 200);
      };
      evs.forEach(function (e) { window.addEventListener(e, start, { capture: true, passive: true }); });
    })();
    qa('.thumbs .ph-img[data-src]').forEach(function (th) {
      th.addEventListener('click', function () { showMain(th.dataset.src, th.dataset.alt); });
    });

    /* swatches and size buttons (rendered by Liquid) drive slot 1 */
    qa('.sw').forEach(function (b) { b.addEventListener('click', function () { swatchClicked = true; setSlot(0, { colour: b.dataset.colour }); }); });
    qa('.size[data-size]').forEach(function (b) { b.addEventListener('click', function () { setSlot(0, { size: b.dataset.size }); }); });

    /* bundle cards */
    qa('.bundle').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('select, option')) return;
        active = +b.dataset.n;
        renderPrices();
      });
    });

    /* any button elsewhere on the page with data-nh-select-bundle="2" (the gift band) chooses that card and scrolls to the cards */
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-nh-select-bundle]'); if (!t) return;
      var n = +t.getAttribute('data-nh-select-bundle'); if (!q('.bundle[data-n="' + n + '"]')) return;
      e.preventDefault();
      active = n;
      renderPrices();
      var box = q('.bundles');
      if (box && typeof box.scrollIntoView === 'function') { try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) { box.scrollIntoView(); } }
    });

    /* add to cart: every blanket of the active bundle, one request */
    function selectedItems() {
      var items = {}, order = [];
      slots.slice(0, active).forEach(function (sl) {
        var v = variantOf(sl); if (!v) return;
        if (!items[v.id]) { items[v.id] = 0; order.push(v.id); }
        items[v.id] += 1;
      });
      return order.map(function (id) { return { id: +id, quantity: items[id] }; });
    }

    /* After the add. Three routes, tried in this order:
       1. Horizon: the theme's cart drawer (<cart-drawer-component> inside <theme-drawer id="cart-drawer">)
          refreshes itself from a CartLinesUpdateEvent (@shopify/events, mapped by the theme's importmap)
          whose promise resolves with the new cart and the re-rendered cart-items sections. Verified against
          Shopify/horizon assets/product-form.js, cart-drawer.js, component-cart-items.js, theme-drawer.js (Oct 2026).
       2. Dawn-style <cart-drawer> with renderContents().
       3. The Kaching Cart app drawer (window.kachingCartApi, installed 21 Oct 2026; it replaces the theme drawer):
          refreshCart() then openCart().
       4. The cart page. */
    function horizonDrawer() { return data.afterAdd === 'drawer' ? document.querySelector('cart-drawer-component') : null; }
    function dawnDrawer() { return data.afterAdd === 'drawer' ? document.querySelector('cart-drawer') : null; }
    function cartJson() { return fetch((data.routes.cart || '/cart') + '.json', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
    function goAfterAdd(response) {
      if (data.afterAdd === 'checkout') { window.location.href = (data.routes.root || '/').replace(/\/$/, '') + '/checkout'; return; }
      var dawn = dawnDrawer();
      if (dawn && typeof dawn.renderContents === 'function' && response && response.sections) {
        try { dawn.renderContents(response); return; } catch (e) { /* fall through */ }
      }
      var kc = window.kachingCartApi;
      if (data.afterAdd === 'drawer' && kc && typeof kc.openCart === 'function') {
        try {
          Promise.resolve(typeof kc.refreshCart === 'function' ? kc.refreshCart() : null)
            .catch(function () { return null; })
            .then(function () { kc.openCart(); });
          return;
        } catch (e) { /* fall through */ }
      }
      window.location.href = data.routes.cart || '/cart';
    }

    function addToCart() {
      var items = selectedItems(); var msg = q('.atc-msg');
      if (!items.length) { if (msg) msg.textContent = data.labels.pickError; return; }
      var buttons = qa('[data-atc]'); buttons.forEach(function (b) { b.disabled = true; });
      if (msg) msg.textContent = '';
      var body = { items: items };
      var horizon = horizonDrawer(), dawn = dawnDrawer();
      if (horizon) {
        var ids = [];
        document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId) ids.push(el.dataset.sectionId); });
        if (ids.length) body.sections = ids.join(',');
      } else if (dawn && typeof dawn.getSectionsToRender === 'function') {
        try { body.sections = dawn.getSectionsToRender().map(function (x) { return x.id; }).join(','); body.sections_url = window.location.pathname; } catch (e) { /* ignore */ }
      }
      var eventsP = horizon ? import('@shopify/events').catch(function () { return null; }) : Promise.resolve(null);
      eventsP.then(function (mod) {
        var Ev = mod && mod.CartLinesUpdateEvent, deferred = null;
        if (Ev && typeof Ev.createPromise === 'function') {
          try {
            deferred = Ev.createPromise();
            document.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }), promise: deferred.promise }));
          } catch (e) { deferred = null; }
        }
        var itemCount = items.reduce(function (n, i) { return n + i.quantity; }, 0);
        return fetch((data.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            var errText = !res.ok ? ((res.json && (res.json.description || res.json.message)) || data.labels.addError) : null;
            if (deferred) {
              return cartJson().then(function (ajaxCart) {
                deferred.resolve({
                  cart: typeof Ev.createCartFromAjaxResponse === 'function' ? Ev.createCartFromAjaxResponse(ajaxCart) : ajaxCart,
                  detail: { items: ajaxCart.items, source: 'nh-buy-box', sourceId: root.id, itemCount: itemCount, productId: String(thisM.variants[0] && thisM.variants[0].product_id || ''), sections: res.json && res.json.sections, didError: !res.ok }
                });
                if (errText) throw new Error(errText);
                var td = document.getElementById('cart-drawer');
                if (td && typeof td.open === 'function' && !td.isOpen) td.open();
              }, function (e) { deferred.reject(e); throw e; });
            }
            if (errText) throw new Error(errText);
            goAfterAdd(res.json);
          });
      })
        .catch(function (err) { if (msg) msg.textContent = (err && err.message) || data.labels.addError; })
        .then(function () { buttons.forEach(function (b) { b.disabled = false; }); });
    }
    qa('[data-atc]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); addToCart(); }); });

    /* sticky bar padding on phones */
    if (q('.sticky')) document.body.classList.add('nh-has-sticky');

    /* size guide dialog: shows the page's own size guide section (drawings + dimensions); falls back to the per-size lines */
    (function sizeGuide() {
      var btn = q('[data-nh-size-guide]'), dlg = q('[data-nh-sg]'); if (!btn || !dlg) return;
      var filled = false;
      function fill() {
        if (filled) return; filled = true;
        var grid = [].filter.call(document.querySelectorAll('.sizes2'), function (g) { return !dlg.contains(g); })[0], src = grid && grid.closest('.wrap'), body = dlg.querySelector('[data-nh-sg-body]');
        if (src && body) { var c = src.cloneNode(true); c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); }); body.innerHTML = ''; body.appendChild(c); }
      }
      btn.addEventListener('click', function (e) { e.preventDefault(); fill(); if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', ''); });
      var close = function () { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); };
      dlg.querySelector('[data-nh-sg-close]').addEventListener('click', close);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    })();

    /* test hook: what the add-to-cart would send right now */
    root.nhCartItems = selectedItems;

    renderAll();
  }

  function boot() { document.querySelectorAll('[data-nh-buy-box]').forEach(function (root) { if (!root.dataset.nhReady) { root.dataset.nhReady = '1'; init(root); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
